import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthProvider';

/** Redirects anonymous visitors to /login, remembering where they were going. */
export function RequireAuth({ admin = false }: { admin?: boolean }) {
  const { status, isAdmin } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <p className="p-8 text-center text-slate-500" role="status">Loading...</p>;
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  // Hiding the admin UI from non-admins is a courtesy. Every admin API call is
  // authorised again on the server from the verified token; this check is never trusted.
  if (admin && !isAdmin) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
